/* eslint-disable react/destructuring-assignment */
import Icon from '../Icon';

const PopupPointer = (props) => (
  <Icon {...props}>
    <path
      d="M16.45 2.2132C14.7931 0.595598 12.1069 0.595598 10.45 2.2132L1.45 11H25.45L16.45 2.2132Z"
      fill={props.fill}
    />
    <path
      d="M9.73289 1.49767C11.7782 -0.499224 15.0847 -0.499224 17.1301 1.49767L26.863 11H25.4315L16.4315 2.2132C14.7746 0.595599 12.0883 0.595599 10.4315 2.2132L1.43147 11H0L9.73289 1.49767Z"
      fill={props.color}
    />
  </Icon>
);

export default PopupPointer;
